<app-geo-territoire-search
  [type]="'list'"
  (geoterritoire)="onGeoTerritoireChange($event)"
></app-geo-territoire-search>

<ng-template #entiteSearchFilterHeader>
  {{ title }}
</ng-template>
